<div class="w-full h-full">
<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <p-toolbar>
    <ng-template #start>
      <div class="flex space-x-2 toolbar-menu">

        <p-selectButton [options]="singleMultiple" [(ngModel)]="selectedSingleMultiple"
          (onChange)="modeToggle($event)" [allowEmpty]="false"></p-selectButton>

        @if (selectedSingleMultiple === 'singleAnnulus') {
          <p-select
            [options]="resultTypesDropdown" (onChange)="dropdownChange($event)"
            [(ngModel)]="selectedResultType" optionLabel="header" optionValue="value"
            appendTo="body"></p-select>
        } @else {
          <app-units-select-input
            [options]="annulusNames"
            (onChange)="dropdownChange($event)" [(ngModel)]="selectedAnnulus"
            optionLabel="label" dataKey="value"
            [optionLabelFormatter]="formatAnnulusOption"
            [unit]="shortLengthUnit"
            ariaLabel="Annular result location"
            appendTo="body"></app-units-select-input>
        }

        @if (selectedSingleMultiple === 'multipleAnnuli') {
          <p-selectButton
            [options]="fluidGasDisplay" [(ngModel)]="selectedFluidGas"
            (onChange)="onSelectFluidGas($event)" [allowEmpty]="false">
          </p-selectButton>
        } @else {
          <p-selectButton
            [options]="resultsDisplay" [(ngModel)]="selectedResultsDisplay"
            (onChange)="onSelectedResultsDisplayUpdated($event)" [allowEmpty]="false">
          </p-selectButton>
        }

        @if (selectedResultsDisplay === 'plot') {
          <p-selectButton [options]="depthView"
            [(ngModel)]="selectedDepthView" (onChange)="depthViewToggle($event)"
            [allowEmpty]="false">
          </p-selectButton>
        }

      </div>
    </ng-template>

    <ng-template #center>
      <p-select [options]="operations" [(ngModel)]="selectedOperation"
        (onChange)="onOperationSelected($event)" optionLabel="name" appendTo="body">
      </p-select>

      @if (phases?.length > 1) {
        <p-select [options]="phases" [ngModel]="selectedPhase"
          (onChange)="onPhaseSelected($event)" optionLabel="phaseNumber" appendTo="body">
          <ng-template pTemplate="selectedItem">
            Phase {{ selectedPhase?.phaseNumber }}
          </ng-template>
          <ng-template let-phase pTemplate="item">
            Phase {{ phase.phaseNumber }}
          </ng-template>
        </p-select>
      }
    </ng-template>

    <ng-template #end></ng-template>
  </p-toolbar>

  <div class="flex-1 min-h-0 overflow-hidden" [hidden]="selectedResultsDisplay !== 'grid'">
    <app-perical-results-grid
      tableName="Annular Results"
      [tableData]="resultsGrid"
      [columnDefinitions]="
        selectedSingleMultiple === 'singleAnnulus'
          ? cols
          : multipleResultHeaders
      "
      [selectedOperation]="selectedOperation"
      [virtualScroll]="true"
    />
  </div>

  @if (selectedResultsDisplay === 'plot') {
    <app-thermal-results-plot [xAxisRange]="xAxisRange" class="flex-1 min-h-0"
      xAxisTitle="{{ xAxisTitle }}" depthUnit="{{ depthUnit }}" plotTitle="Annular Results" [plotData]="results"
      [columnDefinitions]="cols" [selectedDepthDisplay]="selectedDepthView"
      [isAnnularResults]="true" [plotName]="plotName"
      [selectedDepthDisplay]="selectedDepthView"
      [thermalResultsStore]="annularResultsStore"
    ></app-thermal-results-plot>
  }
</app-tool-loader>

<p-dialog [draggable]="false" [(visible)]="missingOperations" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label> No Operations Exist: Please specify at least one operation to view results.</label>
  <br />
  <br />
</p-dialog>

<p-dialog [draggable]="false" [(visible)]="needToCalculate" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label>{{ calculationError }}</label>
  <br />
  <br />
</p-dialog>
<p-dialog [draggable]="false" [(visible)]="resultsNotUpToDate" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label> New result fields have been added. Please dirty results and recalculate to see the latest results.</label>
  <br />
  <br />
</p-dialog>
</div>
